/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.0.0
 */
import { SagaIterator } from '@redux-saga/core';
import { put, take } from 'redux-saga/effects';

import { API_HOSTNAME, IS_USER_CACHED } from '../../../modules/app/Api';
import { setRequestParams, startPolling, stopPolling } from '../../../modules/polling/pollingActions';
import { STOP_POLLING } from '../../../modules/polling/pollingConstants';
import { setCookie, storageRemoveCookie } from '../../../modules/storage/storageActions';
import { ECookieKey } from '../../../modules/storage/storageTypes';
import { cacheUserDataStartFailure, cacheUserDataStartSuccessful } from '../actions/authCacheActions';

/**
 * @description Saga for initiate asynchronous procedure of loading user data to cache.
 * @return {SagaIterator}
 */
export function* cacheUserDataStartSaga(): SagaIterator {
    try {

        // Remember cache waiting start
        yield put(setCookie({
            key: ECookieKey.CACHE_IN_PROGRESS,
            value: true,
        }));

        // Set parameters for long polling
        yield put(setRequestParams({
            duration: 3000,
            method: 'GET',
            path: API_HOSTNAME + IS_USER_CACHED,
            headers: {
                'Content-Type': 'application/json',
                'X-NODE': 'sticky',
            },
        }));

        // Start long polling
        yield put(startPolling());
        yield take(STOP_POLLING);
        yield put(cacheUserDataStartSuccessful());
    } catch (error: any) {
        yield put(stopPolling());
        yield put(cacheUserDataStartFailure(error));
    }
}

export function* cacheUserDataStartSuccessfulSaga() {

    // Cached ok
    yield put(storageRemoveCookie({
        key: ECookieKey.CACHE_IN_PROGRESS,
    }));
}
